export default __webpack_public_path__ + "0fb8dfa.png";